import { render, staticRenderFns } from "./addon_update.vue?vue&type=template&id=2a52af93"
import script from "./addon_update.vue?vue&type=script&lang=js"
export * from "./addon_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports